
import { IDataType } from '../@commonTypes/database';

export default class LocalStorageWrapper {

  setItem(key: string, value: string) {
    try {
      /** Currenlty no encryption is handled */
      localStorage.setItem(key, value);
    } catch (err) {
      // console.log(err, STRING_WRITE_ERROR);
    }
  }
  getItem(key: string): string {
    try {
      return localStorage.getItem(key) || "";
    } catch (err) {
      // console.log(err, STRING_READ_ERROR);
    }
    return "";
  }
  removeItem(key: string) {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      // console.error(error, STRING_REMOVE_ERROR);
    }
  }

  saveData(key: string, data: any, dataType: IDataType): boolean {
    try {
      switch (dataType) {
        case IDataType.string:
        case IDataType.number:
        case IDataType.bool:
          localStorage.setItem(key, data);
          break;
        case IDataType.array:
        case IDataType.object:
          localStorage.setItem(key, JSON.stringify(data));
          break;
      }
      return true;
    } catch (err) {
      // console.log(err, WRITE_ERROR);
    }
    return false;
  }
  readData<T>(key: string, dataType: IDataType): T | null {
    try {
      switch (dataType) {
        case IDataType.string:
          return localStorage.getItem(key) as T;
        case IDataType.number:
          return Number(localStorage.getItem(key)) as T;
        case IDataType.bool:
          // check for false case bcoz false will comes as an string false
          return Boolean(localStorage.getItem(key)) as T;
        case IDataType.object:
        case IDataType.array:
          try {
            const data: T = JSON.parse(localStorage.getItem(key) as string);
            return data;
          } catch (error) {
            // console.log(error, PARSE_ERROR);
          }
          return null;
        default:
          break;
      }
    } catch (err) {
      // console.log(err, READ_ERROR);
    }
    return null;
  }
  removeData(key: string) {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      // console.log(error, REMOVE_ERROR);
    }
  }
}
